 /**
 * @file
 * Global utilities.
 *
 */
(function ($, Drupal, once) {

  'use strict';

  Drupal.behaviors.weaver = {

    backTop: function() {
      window.scrollTo(0,0);
      document.querySelector('#main').focus();
    },

    toggleTakeover: function(takeover, triggers) {
      takeover.classList.toggle('active');
      document.body.classList.toggle('takeover-nav-active');
      
      triggers.forEach((trigger) => {
        let expandedValue = (trigger.getAttribute('aria-expanded') === 'true') ? 'false' : 'true';
        trigger.setAttribute('aria-expanded', expandedValue);
      });

      // if expanded, set focus on first item
      if (takeover.classList.contains('active')) {
        takeover.querySelector('#takeover-nav--links li:first-child a').focus();
      } else {
        document.querySelector('#header [data-toggle="takeoverNav"]').focus();
      }
    },

    mobileSecondColumnImageOrderChange: function() {
      const layoutSecondColumns = document.querySelectorAll('.layout-second');
      if (layoutSecondColumns.length <= 0) {
        return;
      }

      // check if second column first paragraph is an image and change order for mobile
      // doing this because doesn't seem to be a way to update layout region classes directly
      layoutSecondColumns.forEach((column) => {
        let firstParagraph = column.querySelector('.paragraph');
        if (!firstParagraph.classList.contains('paragraph--type--weaver-bigimage')) {
          return;
        }

        column.classList.add('order-1', 'order-xl-2', 'pb-6', 'pb-xl-0');
        column.parentNode.querySelector('.layout-first').classList.add('order-2', 'order-xl-1');
      });
    },

    youtubeLazyLoad: function(youtubeWrapper) {
      let iframe = youtubeWrapper.querySelector('iframe');
      if (iframe != null && iframe.dataset.src != null) {
        iframe.setAttribute('src', iframe.dataset.src);
      }
    },

    attach: function (context, settings) {
          
      // ensures javascript runs only once per page load and not with every ajax call
      $(once('weaver', 'body', context)).each(function () {

        const weaver = Drupal.behaviors.weaver;

        /////////////////////////////////////////
        // BACK TO TOP
        const backtop = document.getElementById('back-top');
        if (backtop != null) {
          backtop.addEventListener('click', function() {
            weaver.backTop();
          });
        }

        //////////////////////////////////////////
        // BODY add loaded class
        setTimeout(() => {
          document.body.classList.add('loaded');
        }, 500);

        ///////////////////////////////////////
        // LAYOUT CHANGES FOR MOBILE
        weaver.mobileSecondColumnImageOrderChange();

        ///////////////////////////////////////
        // LAZY LOAD

        const lazyBgImages = document.querySelectorAll('[data-bgimage]');
        if (lazyBgImages != null) {

          // get animation classes for the elements
          lazyBgImages.forEach((lazyBgImage) => {
            var observer = new IntersectionObserver((entries) => {
                lazyLoadingBgImageCallback(entries, observer, lazyBgImage);
                }, 
                { threshold: 0.25 });
                observer.observe(lazyBgImage);
            });

          let lazyLoadDelay = 0;

          const lazyLoadingBgImageCallback = (entries, observer, element) => {
            entries.forEach((entry, lazyLoadingElement) => {
              if (entry.isIntersecting) {
                setTimeout(() => {
                  entry.target.style.backgroundImage = 'url(' + entry.target.dataset.bgimage + ')';
                }, lazyLoadDelay);
              }
            });
          };
        }

        ///////////////////////////////////////
        // MAIN CONTENT


        ///////////////////////////////////////
        // MOBILE NAV


        ///////////////////////////////////////
        // POPOVERS
        // enable all popovers
        $('[data-toggle="popover"]').popover({
          html: true
        });

        ///////////////////////////////////////
        // SEARCH


        ///////////////////////////////////////
        // SHARE COPY LINK
        // copies URL when clicked
        const shareLinks = document.querySelectorAll('.share-copy-link');
        if (shareLinks.length > 0) {
          shareLinks.forEach((shareLink) => {
            shareLink.addEventListener('click', () => {
              navigator.clipboard.writeText(window.location.href);
              shareLink.classList.add('active');
              setTimeout(() => {
                shareLink.classList.remove('active');
              }, 2000);
            });
          });
        }

        ///////////////////////////////////////
        // TABLES
        // // turn tables added via CKEditor into responsive ones
        const responsiveTablesText = (responsiveTables) => {
          let horizontalTableScrollText = '<p class="horizontal-scroll-notice text-center font-size-sm font-weight-bold d-block d-lg-none">Scroll left and right to view more columns</p>';

          responsiveTables.forEach((rTable) => {
            // count number of table rows
            let rTableRows = rTable.querySelectorAll('tr');

            if (!rTable.querySelector('.horizontal-scroll-notice')) {
              let rTableContainer = rTable.parentNode;
              $(once(rTableContainer)).prepend(horizontalTableScrollText);
              $(once(rTableContainer)).append(horizontalTableScrollText);
            }
          });
        };

        let responsiveTables = document.querySelectorAll('.table-responsive');
        if (responsiveTables) {
          responsiveTablesText(responsiveTables);
        }
        $(document).ajaxComplete(function (event, xhr, settings) {
          let responsiveTables = document.querySelectorAll('.table-responsive');
          if (responsiveTables) {
            responsiveTablesText(responsiveTables);
          }
        });

        ///////////////////////////////////////
        // TABS
        $('.tab-pane').tab();

        ///////////////////////////////////////
        // TAKEOVER NAV
        const takeoverNav = document.getElementById('takeover-nav');
        const takeoverTriggers = document.querySelectorAll('[data-toggle="takeoverNav"]');
        const takeoverOverlay = document.getElementById('takeover-nav-cover');
        
        if (takeoverNav != null && takeoverTriggers != null) {
          takeoverTriggers.forEach((takeoverTrigger) => {
            takeoverTrigger.addEventListener('click', (e) => {
              e.preventDefault();
              weaver.toggleTakeover(takeoverNav, takeoverTriggers);
            });
          });
        }

        if (takeoverOverlay != null) {
          takeoverOverlay.addEventListener('click', () => {
            weaver.toggleTakeover(takeoverNav, takeoverTriggers);
          });
        }
                  
        ///////////////////////////////////////
        // TOOLTIPS

        let tooltipStatus = true;

        if (window.innerWidth < 992) {
          tooltipStatus = false;
        }

				// enable all tooltips, but not on mobile
        if (tooltipStatus === true) {
			    const tooltipToggles = document.querySelectorAll('[data-toggle="tooltip"]');

          if (tooltipToggles) {
            tooltipToggles.forEach((tooltipToggle) => {

              $(tooltipToggle).tooltip({
                animation: true,
                delay: { show: 500 },
                trigger: 'hover'
              });
            });
          }
        }

        /////////////////////////////
        // YOUTUBE
        const youtubeContainer = document.querySelector('.field--name-field-bcfed-youtube');
        const youtubeWrappers = document.querySelectorAll('[data-video="youtube"]');
        if (youtubeWrappers != null) {
          youtubeWrappers.forEach((youtubeWrapper) => {
            $(youtubeWrapper).on('shown.bs.collapse', function(e) {
             weaver.youtubeLazyLoad(youtubeWrapper);
             youtubeContainer.scrollIntoView();
            });
          });
        }

        // KEYBOARD SHORTCUTS
        document.addEventListener('keyup', (e) => {
          // console.log(e.which);
          let mobileNav = document.getElementById('mobile-navbar');
          // CTRL+ALT+M
          // if (e.ctrlKey && e.altKey && e.which == 77) {
          //   // toggle accessibility Menu
          //   let mobileNav = document.getElementById('mobile-navbar');
          //   if (mobileNav != null) {
          //     mobileNav.classList.add('show');
          //     mobileNav.querySelector('ul > li > a').focus();
          //     mobileNav.querySelectorAll('a').forEach((mobileNavLink) => {
          //       mobileNavLink.setAttribute('tabindex', 0);
          //     });
          //   }
          // }
          // up arrow
          if (e.ctrlKey && e.altKey && e.which == 38) {
            // scroll to top
            weaver.backTop();
          }
          // down arrow
          if (e.ctrlKey && e.altKey && e.which == 40) {
            // scroll to bottom
            window.scrollTo(0, 9999999);
            document.querySelector('#block-footermenu li a').focus();
          }
          // enter should open collapses
          if (e.which == 13) {
            if (e.target.dataset.toggle == 'collapse') {
              e.target.click();
            }
          }
          // escape should close mobileNav amd takeover
          if (e.which == 27) {
            if (mobileNav != null && mobileNav.classList.contains('show')) {
              mobileNav.classList.remove('show');
            }
            if (document.body.classList.contains('takeover-nav-active')) {
              weaver.toggleTakeover(takeoverNav, takeoverTriggers);
            }
          }
          // CTRL M to open takeover
          if (e.ctrlKey && e.altKey && e.which == 77) {
            if (!document.body.classList.contains('takeover-nav-active')) {
              weaver.toggleTakeover(takeoverNav, takeoverTriggers);
            }
          }

        });

      });

    }
  };

})(jQuery, Drupal, once);
